import { platformApiFetch } from '@/services/platformApi/client';
import type { AppUser } from '@/types/supabase';

export type AuthSessionResponse = {
  user: AppUser | null;
};

export async function fetchAuthSession(): Promise<AuthSessionResponse> {
  return platformApiFetch<AuthSessionResponse>('/v1/auth/session', {
    cache: 'no-store',
  });
}

export async function getCurrentAuthUser(): Promise<AppUser | null> {
  const { user } = await fetchAuthSession();
  return user;
}